import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import Seo from "../components/Seo";
import Navbar from "../components/Navbar";
import Marquee from "../components/Marquee";
import Hero from "../sections/Hero";
import Services from "../sections/Services";
import WhyUs from "../sections/WhyUs";
import About from "../sections/About";
import Pricing from "../sections/Pricing";
import Faq from "../sections/Faq";
import Booking from "../sections/Booking";
import Contact from "../sections/Contact";
import Footer from "../sections/Footer";
import { useContent } from "../hooks/useContent";

export default function Landing() {
  const { content } = useContent();
  const location = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => lenis?.scrollTo(location.hash, { offset: -64, duration: 1.2 }), 500);
      return () => clearTimeout(t);
    }
  }, [location.hash, lenis]);

  return (
    <div className="bg-[#050505] text-white min-h-screen font-body" data-testid="landing-page" id="top">
      <Seo
        title="TheMapLab | ECU Remapping, Stage 1 Tuning & Diagnostics — Rochdale"
        description="TheMapLab — professional ECU remapping, Stage 1 tuning and vehicle diagnostics in Rochdale, serving Greater Manchester. Unlock your vehicle's potential."
        canonical="https://themaplab.co.uk/"
      />
      <div className="grain" />
      <Navbar />
      <main>
        <Hero content={content} />
        <Marquee />
        <Services content={content} />
        <WhyUs content={content} />
        <About content={content} />
        <Marquee reverse />
        <Pricing content={content} />
        <Faq content={content} />
        <Booking content={content} />
        <Contact content={content} />
      </main>
      <Footer content={content} />
    </div>
  );
}
